export default "__VITE_ASSET__Qe3Va2pg__"